import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { AuthShell, AuthIcon } from '../../components/layout/AuthShell';
import { Mail, ArrowLeft, CheckCircle2 } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      testId="forgot-password-page"
      eyebrow="Passwort"
      title={<>Passwort <span className="serif-it text-purple">vergessen?</span></>}
      intro="Kein Problem! Wir senden dir einen Link zum Zurücksetzen."
    >
      {sent ? (
        <div className="text-center py-2" data-testid="forgot-password-sent">
          <AuthIcon tone="green"><CheckCircle2 className="w-8 h-8" /></AuthIcon>
          <h2 className="text-xl font-bold mb-2">E-Mail gesendet!</h2>
          <p className="text-ink/80 mb-4">
            Falls ein Konto mit dieser E-Mail existiert, erhältst du in Kürze eine E-Mail mit einem Link zum Zurücksetzen deines Passworts.
          </p>
          <p className="text-ink/60 mb-6">Bitte prüfe auch deinen Spam-Ordner.</p>
          <Button asChild variant="outline" className="btn--block">
            <Link to="/login" data-testid="forgot-password-back-login">
              <ArrowLeft className="w-4 h-4" />
              Zurück zur Anmeldung
            </Link>
          </Button>
        </div>
      ) : (
        <>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="email" className="mb-2 block">E-Mail-Adresse</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ihre@email.de"
                required
                data-testid="forgot-password-email"
              />
            </div>

            {error && (
              <p className="text-red-700 font-medium" data-testid="forgot-password-error">{error}</p>
            )}

            <Button type="submit" disabled={loading} className="btn--block" data-testid="forgot-password-submit">
              {loading ? 'Wird gesendet...' : (<><Mail className="w-5 h-5" />Link senden</>)}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <Link to="/login" className="inline-flex items-center gap-1 text-ink/80 hover:text-ink" data-testid="forgot-password-login-link">
              <ArrowLeft className="w-4 h-4" />
              Zurück zur Anmeldung
            </Link>
          </div>
        </>
      )}
    </AuthShell>
  );
};

export default ForgotPasswordPage;
